import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

type Props = {
  open: boolean;
  loading?: boolean;
  cableId?: string | null;
  cableType?: string;
  cableColor?: string;
  onClose: () => void;
  onConfirm: () => void;
};

export default function CableDeleteDialog({
  open,
  loading = false,
  cableId,
  cableType,
  cableColor,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="cable-delete-title"
    >
      <DialogTitle
        id="cable-delete-title"
        sx={{
          pr: 6,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <WarningAmberIcon color="warning" sx={{ mb: "2px" }} />
        Delete cable?
        <IconButton
          aria-label="close"
          onClick={onClose}
          disabled={loading}
          edge="end"
          sx={{ position: "absolute", right: 20, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          This action will permanently remove the selected cable. You can’t undo
          this.
        </Typography>

        {/*{(cableId || cableType || cableColor) && (
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {cableId && <Chip size="small" label={`ID: ${cableId}`} />}
            {cableType && <Chip size="small" label={`Type: ${cableType}`} />}
            {cableColor && <Chip size="small" label={`Color: ${cableColor}`} />}
          </Stack>
        )}*/}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
